import { create, invalidator, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

// import { delay } from '@holmescorp/common';
import { createNlsMiddleware, keymap, lccstate, userstate } from '@holmescorp/lcc-state';
import { ParentTree } from '@holmescorp/lcc-interfaces';

import { AssessViz } from './assess-viz';

import css from '../css/prepost-viz.m.css';

export interface PrePostVizProperties {
	whichtest: 'posttest' | 'practice';
}

const nls = createNlsMiddleware('ditabook');
const factory = create({ theme, nls, lccstate, userstate, invalidator }).properties<PrePostVizProperties>();

export const PrePostViz = factory(({ properties, middleware: { theme, nls, lccstate, userstate } }) => {
	const { whichtest } = properties();
	const { get, path } = userstate;
	const assessment: ParentTree = get(path('assessment'));
	const testresults: ParentTree = whichtest === 'practice' ? get(path('practice')) : get(path('posttest', 'tree'));
	const roots: string[] = lccstate.get(lccstate.path('ditaroots'));

	const {
		messages: {
			prepost_viz_score = '[ditabook] prepost_viz_score',
			prepost_viz_pretest = '[ditabook] prepost_viz_pretest'
		}
	} = nls();
	const themeCss = theme.classes(css);

	// ensure testresults have been set up
	const root0 = roots[0];
	if (testresults[root0] === undefined || testresults[root0].data === undefined) {
		/*
		(async () => {
			await delay(500);
			invalidator();
		})();
		*/
		return v('div', { key: 'root', xqa: `viz`, classes: [themeCss.root] }, []);
	}

	const kids = roots.map((root) => {
		const { title = root, id = root } = keymap.get(root) || {};
		const assessmentTopic = assessment[id] ? assessment[id] : assessment[root];
		const assessBase: number = assessmentTopic.data.percent;
		const assess: number = assessBase > 1.0 ? assessBase / 100.0 : assessBase;
		const percentBase: number = testresults[id].data.percent;
		const percent: number = percentBase > 1.0 ? percentBase / 100.0 : percentBase;
		const xqa = `${whichtest}-viz ${id}`;
		return w(AssessViz, { xqa, title, percent, assess });
	});

	return v('div', { key: 'root', xqa: `viz`, classes: [themeCss.root] }, [
		v('div', { key: `scores`, role: 'list', xqa: `viz ${whichtest}`, classes: [themeCss.scoreblock] }, kids),
		v('div', { classes: [themeCss.legend] }, [
			v('div', { key: 'legend-score' }, [
				v('span', { classes: [themeCss.scoreIcon] }, [`\u25a0 `]),
				v('span', {}, [prepost_viz_score])
			]),
			v('div', { key: 'legend-assess' }, [
				v('span', { classes: [themeCss.assessIcon] }, [`\u2666 `]),
				v('span', {}, [prepost_viz_pretest])
			])
		])
	]);
});
